import React from 'react';
import { Mail, Globe, ExternalLink } from 'lucide-react';

const Contact = ({ theme, business }) => (
  <section style={{
    backgroundColor: theme.colors.background,
    borderRadius: theme.borderRadius.lg,
    boxShadow: theme.shadows.md,
    padding: '40px',
    marginBottom: '40px'
  }}>
    <h2 style={{
      fontFamily: theme.fonts.heading, color: theme.colors.heading,
      fontSize: '2rem', margin: '0 0 30px 0', textAlign: 'center'
    }}>
      Get In Touch
    </h2>
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
      {business.social?.facebook && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            backgroundColor: '#1877F2', color: '#ffffff', width: '60px', height: '60px',
            borderRadius: '50%', display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 15px'
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </div>
          <h3 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, margin: '0 0 10px 0' }}>Facebook</h3>
          <a data-field="facebook" href={business.social.facebook} target="_blank" rel="noopener noreferrer" style={{
            color: theme.colors.primary, textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'
          }}>
            Visit Page <ExternalLink size={16} />
          </a>
        </div>
      )}
      {business.email && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            backgroundColor: theme.colors.secondary, color: theme.colors.background,
            width: '60px', height: '60px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px'
          }}>
            <Mail size={24} />
          </div>
          <h3 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, margin: '0 0 10px 0' }}>Email</h3>
          <a data-field="email" href={`mailto:${business.email}`} style={{
            color: theme.colors.primary, textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500'
          }}>
            {business.email}
          </a>
        </div>
      )}
      {business.website && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            backgroundColor: theme.colors.accent, color: theme.colors.background,
            width: '60px', height: '60px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px'
          }}>
            <Globe size={24} />
          </div>
          <h3 style={{ fontFamily: theme.fonts.heading, color: theme.colors.heading, margin: '0 0 10px 0' }}>
            {business.website?.includes('etsy.com') ? 'Etsy Shop' : 'Website'}
          </h3>
          <a data-field="website" href={business.website} target="_blank" rel="noopener noreferrer" style={{
            color: theme.colors.primary, textDecoration: 'none', fontSize: '1.1rem', fontWeight: '500',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px'
          }}>
            {business.website?.includes('etsy.com') ? 'Visit Etsy Shop' : 'Visit Website'} <ExternalLink size={16} />
          </a>
        </div>
      )}
    </div>
  </section>
);

export default Contact;
